<template>
  <div style="z-index: 1">
    <svg version="1.1" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 77.954 74.231">
      <title>{{ hint }}</title>
      <defs>
        <linearGradient id="green_1_" gradientUnits="userSpaceOnUse" x1="53.9507" y1="2.499" x2="53.9507" y2="22.61">
          <stop offset="0" style="stop-color: #009d00" />
          <stop offset="0.15" style="stop-color: #00b700" />
          <stop offset="0.5" style="stop-color: #00ff00" />
          <stop offset="0.85" style="stop-color: #00b700" />
          <stop offset="1" style="stop-color: #009d00" />
        </linearGradient>
        <linearGradient id="green_2_" gradientUnits="userSpaceOnUse" x1="74.1719" y1="0" x2="74.1719" y2="25">
          <stop offset="0" style="stop-color: #009100" />
          <stop offset="0.0824" style="stop-color: #00a700" />
          <stop offset="0.2824" style="stop-color: #00d600" />
          <stop offset="0.4356" style="stop-color: #00f400" />
          <stop offset="0.5225" style="stop-color: #00ff00" />
          <stop offset="0.599" style="stop-color: #00f500" />
          <stop offset="0.7277" style="stop-color: #00db00" />
          <stop offset="0.892" style="stop-color: #00b100" />
          <stop offset="1" style="stop-color: #009100" />
        </linearGradient>
        <linearGradient id="green_3_" gradientUnits="userSpaceOnUse" x1="32.6431" y1="91.4229" x2="32.6431"
          y2="59.5944">
          <stop offset="0" style="stop-color: #00c900" />
          <stop offset="0.2287" style="stop-color: #00c600" />
          <stop offset="0.4206" style="stop-color: #00bb00" />
          <stop offset="0.5993" style="stop-color: #00aa00" />
          <stop offset="0.7699" style="stop-color: #009200" />
          <stop offset="0.9334" style="stop-color: #007300" />
          <stop offset="1" style="stop-color: #006400" />
        </linearGradient>
        <radialGradient id="green_4_" cx="58.1841" cy="61.0923" r="247.0021" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #009d00" />
          <stop offset="0.2033" style="stop-color: #00b700" />
          <stop offset="0.5055" style="stop-color: #00ff00" />
          <stop offset="0.85" style="stop-color: #00b700" />
          <stop offset="1" style="stop-color: #009d00" />
        </radialGradient>
        <linearGradient id="green_5_" gradientUnits="userSpaceOnUse" x1="-208.5039" y1="1024.1396" x2="-263.7707"
          y2="970.7787" gradientTransform="matrix(0.7071 0.7071 -0.7071 0.7071 904.2394 -534.6737)">
          <stop offset="0" style="stop-color: #009d00" />
          <stop offset="0.15" style="stop-color: #00b700" />
          <stop offset="0.5" style="stop-color: #00ff00" />
          <stop offset="0.85" style="stop-color: #00b700" />
          <stop offset="1" style="stop-color: #009d00" />
        </linearGradient>
        <linearGradient id="green_6_" gradientUnits="userSpaceOnUse" x1="1686.7451" y1="2101.1055" x2="1686.7451"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #00c900" />
          <stop offset="0.2287" style="stop-color: #00c600" />
          <stop offset="0.4206" style="stop-color: #00bb00" />
          <stop offset="0.5993" style="stop-color: #00aa00" />
          <stop offset="0.7699" style="stop-color: #009200" />
          <stop offset="0.9334" style="stop-color: #007300" />
          <stop offset="1" style="stop-color: #006400" />
        </linearGradient>
        <linearGradient id="green_7_" gradientUnits="userSpaceOnUse" x1="1644.8486" y1="2101.1055" x2="1644.8486"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #00c900" />
          <stop offset="0.2287" style="stop-color: #00c600" />
          <stop offset="0.4206" style="stop-color: #00bb00" />
          <stop offset="0.5993" style="stop-color: #00aa00" />
          <stop offset="0.7699" style="stop-color: #009200" />
          <stop offset="0.9334" style="stop-color: #007300" />
          <stop offset="1" style="stop-color: #006400" />
        </linearGradient>
        <linearGradient id="green_8_" gradientUnits="userSpaceOnUse" x1="2398.7832" y1="1250.1396" x2="2373.5464"
          y2="1225.7731" gradientTransform="matrix(-0.7071 -0.7071 0.7071 -0.7071 844.6611 2611.9207)">
          <stop offset="0" style="stop-color: #009d00" />
          <stop offset="0.15" style="stop-color: #00b700" />
          <stop offset="0.5" style="stop-color: #00ff00" />
          <stop offset="0.85" style="stop-color: #00b700" />
          <stop offset="1" style="stop-color: #009d00" />
        </linearGradient>
        <linearGradient id="green_9_" gradientUnits="userSpaceOnUse" x1="27.6089" y1="26.6934" x2="53.4602"
          y2="70.4417">
          <stop offset="0" style="stop-color: #000000" />
          <stop offset="0.5" style="stop-color: #003300" />
          <stop offset="1" style="stop-color: #000000" />
        </linearGradient>
        <radialGradient id="green_10_" cx="35.1001" cy="37.0259" r="12.8671" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #009d00" />
          <stop offset="0.2033" style="stop-color: #00b700" />
          <stop offset="0.5055" style="stop-color: #00ff00" />
          <stop offset="0.85" style="stop-color: #00b700" />
          <stop offset="1" style="stop-color: #009d00" />
        </radialGradient>

        <linearGradient id="CP_SVGID_1_" gradientUnits="userSpaceOnUse" x1="53.9507" y1="2.499" x2="53.9507" y2="22.61">
          <stop offset="0" style="stop-color: #9a9da3" />
          <stop offset="0.15" style="stop-color: #b6b7b5" />
          <stop offset="0.5" style="stop-color: #ffffff" />
          <stop offset="0.85" style="stop-color: #b6b7b5" />
          <stop offset="1" style="stop-color: #9a9da3" />
        </linearGradient>
        <linearGradient id="CP_SVGID_2_" gradientUnits="userSpaceOnUse" x1="74.1719" y1="0" x2="74.1719" y2="25">
          <stop offset="0" style="stop-color: #929192" />
          <stop offset="0.0824" style="stop-color: #a7a7a7" />
          <stop offset="0.2824" style="stop-color: #d7d6d7" />
          <stop offset="0.4356" style="stop-color: #f4f4f4" />
          <stop offset="0.5225" style="stop-color: #ffffff" />
          <stop offset="0.599" style="stop-color: #f5f5f5" />
          <stop offset="0.7277" style="stop-color: #dbdbdb" />
          <stop offset="0.892" style="stop-color: #b1b1b1" />
          <stop offset="1" style="stop-color: #929192" />
        </linearGradient>
        <linearGradient id="CP_SVGID_3_" gradientUnits="userSpaceOnUse" x1="32.6431" y1="91.4229" x2="32.6431"
          y2="59.5944">
          <stop offset="0" style="stop-color: #c8c9ca" />
          <stop offset="0.2287" style="stop-color: #c5c6c7" />
          <stop offset="0.4206" style="stop-color: #bbbbbc" />
          <stop offset="0.5993" style="stop-color: #aaaaab" />
          <stop offset="0.7699" style="stop-color: #929292" />
          <stop offset="0.9334" style="stop-color: #747373" />
          <stop offset="1" style="stop-color: #656464" />
        </linearGradient>
        <radialGradient id="CP_SVGID_4_" cx="58.1841" cy="61.0923" r="247.0021" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #9a9da3" />
          <stop offset="0.2033" style="stop-color: #b6b7b5" />
          <stop offset="0.5055" style="stop-color: #ffffff" />
          <stop offset="0.85" style="stop-color: #b6b7b5" />
          <stop offset="1" style="stop-color: #9a9da3" />
        </radialGradient>
        <linearGradient id="CP_SVGID_5_" gradientUnits="userSpaceOnUse" x1="-208.5039" y1="1024.1396" x2="-263.7707"
          y2="970.7787" gradientTransform="matrix(0.7071 0.7071 -0.7071 0.7071 904.2394 -534.6737)">
          <stop offset="0" style="stop-color: #9a9da3" />
          <stop offset="0.15" style="stop-color: #b6b7b5" />
          <stop offset="0.5" style="stop-color: #ffffff" />
          <stop offset="0.85" style="stop-color: #b6b7b5" />
          <stop offset="1" style="stop-color: #9a9da3" />
        </linearGradient>
        <linearGradient id="CP_SVGID_6_" gradientUnits="userSpaceOnUse" x1="1686.7451" y1="2101.1055" x2="1686.7451"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #c8c9ca" />
          <stop offset="0.2287" style="stop-color: #c5c6c7" />
          <stop offset="0.4206" style="stop-color: #bbbbbc" />
          <stop offset="0.5993" style="stop-color: #aaaaab" />
          <stop offset="0.7699" style="stop-color: #929292" />
          <stop offset="0.9334" style="stop-color: #747373" />
          <stop offset="1" style="stop-color: #656464" />
        </linearGradient>

        <linearGradient id="CP_SVGID_7_" gradientUnits="userSpaceOnUse" x1="1644.8486" y1="2101.1055" x2="1644.8486"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #c8c9ca" />
          <stop offset="0.2287" style="stop-color: #c5c6c7" />
          <stop offset="0.4206" style="stop-color: #bbbbbc" />
          <stop offset="0.5993" style="stop-color: #aaaaab" />
          <stop offset="0.7699" style="stop-color: #929292" />
          <stop offset="0.9334" style="stop-color: #747373" />
          <stop offset="1" style="stop-color: #656464" />
        </linearGradient>
        <linearGradient id="CP_SVGID_8_" gradientUnits="userSpaceOnUse" x1="2398.7832" y1="1250.1396" x2="2373.5464"
          y2="1225.7731" gradientTransform="matrix(-0.7071 -0.7071 0.7071 -0.7071 844.6611 2611.9207)">
          <stop offset="0" style="stop-color: #9a9da3" />
          <stop offset="0.15" style="stop-color: #b6b7b5" />
          <stop offset="0.5" style="stop-color: #ffffff" />
          <stop offset="0.85" style="stop-color: #b6b7b5" />
          <stop offset="1" style="stop-color: #9a9da3" />
        </linearGradient>
        <linearGradient id="CP_SVGID_9_" gradientUnits="userSpaceOnUse" x1="27.6089" y1="26.6934" x2="53.4602"
          y2="70.4417">
          <stop offset="0" style="stop-color: #000000" />
          <stop offset="0.5" style="stop-color: #333333" />
          <stop offset="1" style="stop-color: #000000" />
        </linearGradient>
        <radialGradient id="CP_SVGID_10_" cx="35.1001" cy="37.0259" r="12.8671" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #9a9da3" />
          <stop offset="0.2033" style="stop-color: #b6b7b5" />
          <stop offset="0.5055" style="stop-color: #ffffff" />
          <stop offset="0.85" style="stop-color: #b6b7b5" />
          <stop offset="1" style="stop-color: #9a9da3" />
        </radialGradient>

        <linearGradient id="red_1_" gradientUnits="userSpaceOnUse" x1="53.9507" y1="2.499" x2="53.9507" y2="22.61">
          <stop offset="0" style="stop-color: #9a0000" />
          <stop offset="0.15" style="stop-color: #b60000" />
          <stop offset="0.5" style="stop-color: #ff0000" />
          <stop offset="0.85" style="stop-color: #b60000" />
          <stop offset="1" style="stop-color: #9a0000" />
        </linearGradient>
        <linearGradient id="red_2_" gradientUnits="userSpaceOnUse" x1="74.1719" y1="0" x2="74.1719" y2="25">
          <stop offset="0" style="stop-color: #920000" />
          <stop offset="0.0824" style="stop-color: #a70000" />
          <stop offset="0.2824" style="stop-color: #d70000" />
          <stop offset="0.4356" style="stop-color: #f40000" />
          <stop offset="0.5225" style="stop-color: #ff0000" />
          <stop offset="0.599" style="stop-color: #f50000" />
          <stop offset="0.7277" style="stop-color: #db0000" />
          <stop offset="0.892" style="stop-color: #b10000" />
          <stop offset="1" style="stop-color: #920000" />
        </linearGradient>
        <linearGradient id="red_3_" gradientUnits="userSpaceOnUse" x1="32.6431" y1="91.4229" x2="32.6431" y2="59.5944">
          <stop offset="0" style="stop-color: #c80000" />
          <stop offset="0.2287" style="stop-color: #c50000" />
          <stop offset="0.4206" style="stop-color: #bb0000" />
          <stop offset="0.5993" style="stop-color: #aa0000" />
          <stop offset="0.7699" style="stop-color: #920000" />
          <stop offset="0.9334" style="stop-color: #740000" />
          <stop offset="1" style="stop-color: #650000" />
        </linearGradient>
        <radialGradient id="red_4_" cx="58.1841" cy="61.0923" r="247.0021" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #9a0000" />
          <stop offset="0.2033" style="stop-color: #b60000" />
          <stop offset="0.5055" style="stop-color: #ff0000" />
          <stop offset="0.85" style="stop-color: #b60000" />
          <stop offset="1" style="stop-color: #9a0000" />
        </radialGradient>
        <linearGradient id="red_5_" gradientUnits="userSpaceOnUse" x1="-208.5039" y1="1024.1396" x2="-263.7707"
          y2="970.7787" gradientTransform="matrix(0.7071 0.7071 -0.7071 0.7071 904.2394 -534.6737)">
          <stop offset="0" style="stop-color: #9a0000" />
          <stop offset="0.15" style="stop-color: #b60000" />
          <stop offset="0.5" style="stop-color: #ff0000" />
          <stop offset="0.85" style="stop-color: #b60000" />
          <stop offset="1" style="stop-color: #9a0000" />
        </linearGradient>
        <linearGradient id="red_6_" gradientUnits="userSpaceOnUse" x1="1686.7451" y1="2101.1055" x2="1686.7451"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #c80000" />
          <stop offset="0.2287" style="stop-color: #c50000" />
          <stop offset="0.4206" style="stop-color: #bb0000" />
          <stop offset="0.5993" style="stop-color: #aa0000" />
          <stop offset="0.7699" style="stop-color: #920000" />
          <stop offset="0.9334" style="stop-color: #740000" />
          <stop offset="1" style="stop-color: #650000" />
        </linearGradient>
        <linearGradient id="red_7_" gradientUnits="userSpaceOnUse" x1="1644.8486" y1="2101.1055" x2="1644.8486"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #c80000" />
          <stop offset="0.2287" style="stop-color: #c50000" />
          <stop offset="0.4206" style="stop-color: #bb0000" />
          <stop offset="0.5993" style="stop-color: #aa0000" />
          <stop offset="0.7699" style="stop-color: #920000" />
          <stop offset="0.9334" style="stop-color: #740000" />
          <stop offset="1" style="stop-color: #650000" />
        </linearGradient>
        <linearGradient id="red_8_" gradientUnits="userSpaceOnUse" x1="2398.7832" y1="1250.1396" x2="2373.5464"
          y2="1225.7731" gradientTransform="matrix(-0.7071 -0.7071 0.7071 -0.7071 844.6611 2611.9207)">
          <stop offset="0" style="stop-color: #9a0000" />
          <stop offset="0.15" style="stop-color: #b60000" />
          <stop offset="0.5" style="stop-color: #ff0000" />
          <stop offset="0.85" style="stop-color: #b60000" />
          <stop offset="1" style="stop-color: #9a0000" />
        </linearGradient>
        <linearGradient id="red_9_" gradientUnits="userSpaceOnUse" x1="27.6089" y1="26.6934" x2="53.4602" y2="70.4417">
          <stop offset="0" style="stop-color: #000000" />
          <stop offset="0.5" style="stop-color: #330000" />
          <stop offset="1" style="stop-color: #000000" />
        </linearGradient>
        <radialGradient id="red_10_" cx="35.1001" cy="37.0259" r="12.8671" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #9a0000" />
          <stop offset="0.2033" style="stop-color: #b60000" />
          <stop offset="0.5055" style="stop-color: #ff0000" />
          <stop offset="0.85" style="stop-color: #b60000" />
          <stop offset="1" style="stop-color: #9a0000" />
        </radialGradient>
        <linearGradient id="YELLOW_1_" gradientUnits="userSpaceOnUse" x1="53.9507" y1="2.499" x2="53.9507" y2="22.61">
          <stop offset="0" style="stop-color: #9a9d00" />
          <stop offset="0.15" style="stop-color: #b6b700" />
          <stop offset="0.5" style="stop-color: #ffff00" />
          <stop offset="0.85" style="stop-color: #b6b700" />
          <stop offset="1" style="stop-color: #9a9d00" />
        </linearGradient>
        <linearGradient id="YELLOW_2_" gradientUnits="userSpaceOnUse" x1="74.1719" y1="0" x2="74.1719" y2="25">
          <stop offset="0" style="stop-color: #929100" />
          <stop offset="0.0824" style="stop-color: #a7a700" />
          <stop offset="0.2824" style="stop-color: #d7d600" />
          <stop offset="0.4356" style="stop-color: #f4f400" />
          <stop offset="0.5225" style="stop-color: #ffff00" />
          <stop offset="0.599" style="stop-color: #f5f500" />
          <stop offset="0.7277" style="stop-color: #dbdb00" />
          <stop offset="0.892" style="stop-color: #b1b100" />
          <stop offset="1" style="stop-color: #929100" />
        </linearGradient>
        <linearGradient id="YELLOW_3_" gradientUnits="userSpaceOnUse" x1="32.6431" y1="91.4229" x2="32.6431"
          y2="59.5944">
          <stop offset="0" style="stop-color: #c8c900" />
          <stop offset="0.2287" style="stop-color: #c5c600" />
          <stop offset="0.4206" style="stop-color: #bbbb00" />
          <stop offset="0.5993" style="stop-color: #aaaa00" />
          <stop offset="0.7699" style="stop-color: #929200" />
          <stop offset="0.9334" style="stop-color: #747300" />
          <stop offset="1" style="stop-color: #656400" />
        </linearGradient>
        <radialGradient id="YELLOW_4_" cx="58.1841" cy="61.0923" r="247.0021" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #9a9d00" />
          <stop offset="0.2033" style="stop-color: #b6b700" />
          <stop offset="0.5055" style="stop-color: #ffff00" />
          <stop offset="0.85" style="stop-color: #b6b700" />
          <stop offset="1" style="stop-color: #9a9d00" />
        </radialGradient>
        <linearGradient id="YELLOW_5_" gradientUnits="userSpaceOnUse" x1="-208.5039" y1="1024.1396" x2="-263.7707"
          y2="970.7787" gradientTransform="matrix(0.7071 0.7071 -0.7071 0.7071 904.2394 -534.6737)">
          <stop offset="0" style="stop-color: #9a9d00" />
          <stop offset="0.15" style="stop-color: #b6b700" />
          <stop offset="0.5" style="stop-color: #ffff00" />
          <stop offset="0.85" style="stop-color: #b6b700" />
          <stop offset="1" style="stop-color: #9a9d00" />
        </linearGradient>
        <linearGradient id="YELLOW_6_" gradientUnits="userSpaceOnUse" x1="1686.7451" y1="2101.1055" x2="1686.7451"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #c8c900" />
          <stop offset="0.2287" style="stop-color: #c5c600" />
          <stop offset="0.4206" style="stop-color: #bbbb00" />
          <stop offset="0.5993" style="stop-color: #aaaa00" />
          <stop offset="0.7699" style="stop-color: #929200" />
          <stop offset="0.9334" style="stop-color: #747300" />
          <stop offset="1" style="stop-color: #656400" />
        </linearGradient>

        <linearGradient id="YELLOW_7_" gradientUnits="userSpaceOnUse" x1="1644.8486" y1="2101.1055" x2="1644.8486"
          y2="2094.5376" gradientTransform="matrix(-1 0 0 -1 1698.4805 2168.6289)">
          <stop offset="0" style="stop-color: #c8c900" />
          <stop offset="0.2287" style="stop-color: #c5c600" />
          <stop offset="0.4206" style="stop-color: #bbbb00" />
          <stop offset="0.5993" style="stop-color: #aaaa00" />
          <stop offset="0.7699" style="stop-color: #929200" />
          <stop offset="0.9334" style="stop-color: #747300" />
          <stop offset="1" style="stop-color: #656400" />
        </linearGradient>
        <linearGradient id="YELLOW_8_" gradientUnits="userSpaceOnUse" x1="2398.7832" y1="1250.1396" x2="2373.5464"
          y2="1225.7731" gradientTransform="matrix(-0.7071 -0.7071 0.7071 -0.7071 844.6611 2611.9207)">
          <stop offset="0" style="stop-color: #9a9d00" />
          <stop offset="0.15" style="stop-color: #b6b700" />
          <stop offset="0.5" style="stop-color: #ffff00" />
          <stop offset="0.85" style="stop-color: #b6b700" />
          <stop offset="1" style="stop-color: #9a9d00" />
        </linearGradient>
        <linearGradient id="YELLOW_9_" gradientUnits="userSpaceOnUse" x1="27.6089" y1="26.6934" x2="53.4602"
          y2="70.4417">
          <stop offset="0" style="stop-color: #000000" />
          <stop offset="0.5" style="stop-color: #333300" />
          <stop offset="1" style="stop-color: #000000" />
        </linearGradient>
        <radialGradient id="YELLOW_10_" cx="35.1001" cy="37.0259" r="12.8671" gradientUnits="userSpaceOnUse">
          <stop offset="0" style="stop-color: #9a9d00" />
          <stop offset="0.2033" style="stop-color: #b6b700" />
          <stop offset="0.5055" style="stop-color: #ffff00" />
          <stop offset="0.85" style="stop-color: #b6b700" />
          <stop offset="1" style="stop-color: #9a9d00" />
        </radialGradient>

        <rect id="main_pump_item_1" x="29.947" y="2.499" width="48.007" height="20" />
        <rect id="main_pump_item_2" x="70.39" width="7.564" height="25" />
        <polygon id="main_pump_item_3"
          points="25.204,65.155 40.081,65.155 44.686,74.231 60.024,74.231 54.247,58.917 11.038,58.917 5.262,74.231 20.599,74.231 	" />
        <circle id="main_pump_item_4" cx="32.515" cy="34.995" r="32.515" />

        <path id="main_pump_item_5" d="M12.316,14.798c11.154-11.152,29.238-11.152,40.394,0l0,0c11.153,11.156,11.152,29.239-0.001,40.394
		l0,0c-11.154,11.154-29.238,11.154-40.393,0.001l0,0C1.163,44.037,1.163,25.954,12.316,14.798L12.316,14.798z M12.972,15.454
		C2.2,26.265,2.202,43.724,12.973,54.534l0,0c10.813,10.772,28.27,10.773,39.079,0l0,0c10.774-10.809,10.774-28.27,0-39.079l0,0
		C41.242,4.683,23.784,4.683,12.972,15.454L12.972,15.454z" />

        <rect id="main_pump_item_6" x="0.06" y="71.071" width="23.353" height="3.16" />
        <rect id="main_pump_item_7" x="41.955" y="71.071" width="23.353" height="3.16" />

        <path id="main_pump_item_8" d="M41.734,44.218c-5.094,5.093-13.351,5.093-18.445,0l0,0c-5.093-5.095-5.093-13.352,0.001-18.444l0,0
		c5.094-5.095,13.351-5.095,18.444-0.001l0,0C46.828,30.866,46.827,39.123,41.734,44.218L41.734,44.218z M41.435,43.919
		c4.919-4.938,4.919-12.909,0-17.846l0,0c-4.937-4.919-12.909-4.92-17.845,0l0,0c-4.92,4.935-4.92,12.908,0,17.844l0,0
		C28.525,48.837,36.498,48.837,41.435,43.919L41.435,43.919z" />

        <circle id="main_pump_item_9" cx="32.515" cy="34.995" r="10.159" />
        <g id="main_pump_item_91">
          <circle cx="32.514" cy="34.995" r="12.631" />
          <line x1="26.589" y1="26.391" x2="38.139" y2="43.299" />
          <polygon points="25.908,26.855 27.27,25.925 38.818,42.834 37.458,43.763 25.908,26.855 		" />
          <line x1="38.139" y1="26.391" x2="26.589" y2="43.299" />
          <polygon points="25.908,42.834 37.458,25.925 38.818,26.855 27.27,43.763 25.908,42.834 		" />
          <polygon points="20.938,35.819 20.938,34.172 42.674,34.172 42.674,35.819 20.938,35.819 	" />
        </g>
        <circle id="main_pump_item_10" cx="32.515" cy="34.995" r="2.501" />
      </defs>
      <g>
        <!-- mono -->
        <g :visibility="fState[5]">
          <use href="#main_pump_item_1" fill="url(#CP_SVGID_1_)" />
          <use href="#main_pump_item_2" fill="url(#CP_SVGID_2_)" />
          <use href="#main_pump_item_3" fill="url(#CP_SVGID_3_)" />
          <use href="#main_pump_item_4" fill="url(#CP_SVGID_4_)" />
          <use href="#main_pump_item_5" fill="url(#CP_SVGID_5_)" />
          <use href="#main_pump_item_6" fill="url(#CP_SVGID_6_)" />
          <use href="#main_pump_item_7" fill="url(#CP_SVGID_6_)" />
          <use href="#main_pump_item_8" fill="url(#CP_SVGID_8_)" />
          <use href="#main_pump_item_9" fill="url(#CP_SVGID_9_)" />
          <use href="#main_pump_item_91" fill="#7D7D7F" />
          <use href="#main_pump_item_10" fill="url(#CP_SVGID_10_)" />
        </g>
        <!-- red -->
        <g :visibility="fState[3]">
          <use href="#main_pump_item_1" fill="url(#red_1_)" />
          <use href="#main_pump_item_2" fill="url(#red_2_)" />
          <use href="#main_pump_item_3" fill="url(#red_3_)" />
          <use href="#main_pump_item_4" fill="url(#red_4_)" />
          <use href="#main_pump_item_5" fill="url(#red_5_)" />
          <use href="#main_pump_item_6" fill="url(#red_6_)" />
          <use href="#main_pump_item_7" fill="url(#red_6_)" />
          <use href="#main_pump_item_8" fill="url(#red_8_)" />
          <use href="#main_pump_item_9" fill="url(#red_9_)" />
          <use href="#main_pump_item_91" fill="#7D0000" />
          <use href="#main_pump_item_10" fill="url(#red_10_)" />
        </g>
        <!-- yellow -->
        <g :visibility="fState[1]">
          <use href="#main_pump_item_1" fill="url(#YELLOW_1_)" />
          <use href="#main_pump_item_2" fill="url(#YELLOW_2_)" />
          <use href="#main_pump_item_3" fill="url(#YELLOW_3_)" />
          <use href="#main_pump_item_4" fill="url(#YELLOW_4_)" />
          <use href="#main_pump_item_5" fill="url(#YELLOW_5_)" />
          <use href="#main_pump_item_6" fill="url(#YELLOW_6_)" />
          <use href="#main_pump_item_7" fill="url(#YELLOW_6_)" />
          <use href="#main_pump_item_8" fill="url(#YELLOW_8_)" />
          <use href="#main_pump_item_9" fill="url(#YELLOW_9_)" />
          <use href="#main_pump_item_91" fill="#707D00" />
          <use href="#main_pump_item_10" fill="url(#YELLOW_10_)" />
        </g>
        <!-- green -->
        <g :visibility="fState[0]">
          <use href="#main_pump_item_1" fill="url(#green_1_)" />
          <use href="#main_pump_item_2" fill="url(#green_2_)" />
          <use href="#main_pump_item_3" fill="url(#green_3_)" />
          <use href="#main_pump_item_4" fill="url(#green_4_)" />
          <use href="#main_pump_item_5" fill="url(#green_5_)" />
          <use href="#main_pump_item_6" fill="url(#green_6_)" />
          <use href="#main_pump_item_7" fill="url(#green_7_)" />
          <use href="#main_pump_item_8" fill="url(#green_8_)" />
          <use href="#main_pump_item_9" fill="url(#green_9_)" />
          <use href="#main_pump_item_91" fill="#7D7D7F" />
          <use href="#main_pump_item_10" fill="url(#green_10_)" />
        </g>
        <g :visibility="fState[10]">
          <use href="#main_pump_item_1" fill="url(#YELLOW_1_)" />
          <use href="#main_pump_item_2" fill="url(#YELLOW_2_)" />
          <use href="#main_pump_item_3" fill="url(#YELLOW_3_)" />
          <use href="#main_pump_item_4" fill="url(#YELLOW_4_)" />
          <use href="#main_pump_item_5" fill="url(#YELLOW_5_)" />
          <use href="#main_pump_item_6" fill="url(#YELLOW_6_)" />
          <use href="#main_pump_item_7" fill="url(#YELLOW_6_)" />
          <use href="#main_pump_item_8" fill="url(#YELLOW_8_)" />
          <use href="#main_pump_item_9" fill="url(#YELLOW_9_)" />
          <use href="#main_pump_item_91" fill="#707D00" />
          <use href="#main_pump_item_10" fill="url(#YELLOW_10_)" />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import MixinStates from './mixin-states.js'

export default {
  mixins: [MixinStates],
  computed: {
    fState: function () {
      let states = ["hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden"];
      if (!this.PropertyURI) {
        states[5] = "visible";
        return states;
      }
      if (this.binary) {
        if (this.value) {
          states[0] = "visible"
        }
        else {
          states[1] = "visible"
        }
      } else
        this.stateSwitch(states, this.value)

      return states;
    }
  },
}      
</script>
